import React, { useState, useEffect } from "react"
import _ from "lodash"

import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { NumberInput, DropdownInput } from "components/table/carousel/inputs"
import { field_attrs } from "components/table/lib/column-field"

const OCBasic = (props: {rowData: [], field: string, namedItems: {}, defaults: {}, persist: Function}) => {
  const [data, setData] = useState<object|null>(_.get(props, "rowData.othercapitaldetail"));
  const inflationOptions = _.map(props.namedItems['inflation'], (i) => { return {label: i.code, value: i.inflationid} })
  const payoutOptions = _.map(props.namedItems['payout'], (i) => { return {label: i.code, value: i.payoutid} })

  const emptyRecord = {
    new: null,
    renewal: null,
    amtType: props.defaults["ocAmtType"],
    inflation: {
      inflationMode: "namedItem",
      inflationNamedItemId: _.get(props, "defaults.ocInflation.inflationNamedItemId")
    },
    payout: {
      payoutMode: "namedItem",
      payoutNamedItemId: _.get(props, "defaults.ocPayout.payoutNamedItemId")
    }
  }
  if(_.includes(props.defaults["ocAmtType"], "%")) _.set(emptyRecord, "inflation", null)

  useEffect(() => {
    if (!props['rowData'][props.field] || props['rowData'][props.field]['state'] !== 'basic') setData(emptyRecord)
  }, [props['rowData']])

  function updateData(val:any, field:string):void {
    let nextData = _.cloneDeep(data)

    if(field === "inflationNamedItemId") {
      _.set(nextData, "inflation", {
        inflationMode: "namedItem",
        inflationNamedItemId: val
      })
    } else if(field === "payoutNamedItemId") {
      _.set(nextData, "payout", {
        payoutMode: "namedItem",
        payoutNamedItemId: val
      })
    } else if(field === "amtType" && _.includes(val, "%")) {
      _.set(nextData, field, val)
      _.set(nextData, "inflation", null)
    } else {
      _.set(nextData, field, val)
    }

    setData(nextData);
    props.persist({...nextData, state: 'basic'}, 'othercapitaldetail', props.rowData)
  }

  const attrs = (field) => field_attrs('marketlease', props.field)(field)(props.rowData, props)

  return (
    <div>
      <SingleRowCarouselState_s>
        <div>
          <label>New</label>
          <NumberInput
            field="new"
            className="automated billion-input"
            data={data}
            attrs={attrs}
            min={0}
            max={1000000000000}
            readPrecision={4}
            writePrecision={4}
            persist={updateData}/>
        </div>
        <div>
          <label>Renewal</label>
          <NumberInput
            field="renewal"
            className="automated billion-input"
            data={data}
            attrs={attrs}
            min={0}
            max={1000000000000}
            readPrecision={4}
            writePrecision={4}
            persist={updateData}/>
        </div>
        <div>
          <label>Amount Type</label>
          <DropdownInput
            field="amtType"
            className="automated lc-amount-type"
            data={data}
            attrs={attrs}
            default={props.defaults['ocAmtType']}
            options={['Amt', 'Amt/Area', '% of Rent', '% of Rent + Recovery', '% of Rent: Ignore Free', '% of Rent + Recovery: Ignore Free', '% of All Revenues']}
            persist={updateData}/>
        </div>
        <div>
          <label>Inflation</label>
          <DropdownInput
            className="automated tc-basic-ni"
            data={_.get(data, 'inflation')}
            default={_.includes(_.get(data, "amtType"), "%") ? null : _.get(props, "defaults.ocInflation.inflationNamedItemId")}
            disabled={_.includes(_.get(data, "amtType"), "%")}
            attrs={attrs}
            field="inflationNamedItemId"
            filter={true}
            options={inflationOptions}
            persist={updateData}/>
        </div>
        <div>
          <label>Payout</label>
          <DropdownInput
            className="automated tc-basic-ni"
            data={_.get(data, 'payout')}
            default={_.get(props, "defaults.ocPayout.payoutNamedItemId")}
            attrs={attrs}
            field="payoutNamedItemId"
            filter={true}
            options={payoutOptions}
            persist={updateData}/>
        </div>
      </SingleRowCarouselState_s>
    </div>
  )
}

export default OCBasic
